import { render, staticRenderFns } from "./RevenueRegistrationTile.vue?vue&type=template&id=c2c2436e&scoped=true&"
import script from "./RevenueRegistrationTile.vue?vue&type=script&lang=js&"
export * from "./RevenueRegistrationTile.vue?vue&type=script&lang=js&"
import style0 from "./RevenueRegistrationTile.vue?vue&type=style&index=0&id=c2c2436e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c2436e",
  null
  
)

export default component.exports